import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPaypal = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "uuid-d5171219-d02e-44cb-b57d-2d95ece87d3b",
	"data-name": "Layer 1",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 116.18 116.18",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M21.78,47.62h-7.54c-.52,0-.95.37-1.03.88l-3.05,19.32c-.06.38.23.73.62.73h3.6c.52,0,.95-.37,1.03-.88l.82-5.21c.08-.51.52-.88,1.03-.88h2.39c4.96,0,7.83-2.4,8.58-7.16.34-2.08.01-3.72-.96-4.86-1.07-1.26-2.97-1.92-5.49-1.92ZM22.65,54.67c-.41,2.7-2.48,2.7-4.48,2.7h-1.14l.8-5.05c.05-.31.31-.53.62-.53h.52c1.36,0,2.64,0,3.31.78.4.46.52,1.15.37,2.1Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M44.31,54.59h-3.61c-.31,0-.57.22-.62.53l-.16,1.01-.25-.37c-.78-1.13-2.52-1.51-4.26-1.51-3.99,0-7.39,3.02-8.06,7.26-.34,2.11.15,4.13,1.34,5.54,1.1,1.3,2.67,1.84,4.55,1.84,3.21,0,4.99-2.07,4.99-2.07l-.16,1c-.06.38.23.73.62.73h3.25c.52,0,.95-.37,1.03-.88l1.95-12.35c.06-.38-.23-.73-.62-.73ZM39.28,61.61c-.35,2.06-1.98,3.45-4.07,3.45-1.05,0-1.89-.34-2.42-.97-.53-.63-.74-1.53-.57-2.54.33-2.04,1.99-3.47,4.04-3.47,1.02,0,1.86.34,2.41.98.55.65.77,1.55.61,2.55Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M63.53,54.59h-3.63c-.35,0-.67.17-.87.46l-5,7.37-2.12-7.08c-.13-.44-.54-.75-1-.75h-3.56c-.43,0-.73.42-.6.83l3.99,11.72-3.76,5.3c-.3.42,0,.99.51.99h3.62c.34,0,.67-.17.86-.45l12.06-17.41c.29-.42,0-.99-.52-.99Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M75.53,47.62h-7.54c-.51,0-.95.37-1.03.88l-3.05,19.32c-.06.38.23.73.62.73h3.87c.36,0,.67-.26.72-.62l.87-5.48c.08-.51.52-.88,1.03-.88h2.38c4.97,0,7.83-2.4,8.58-7.16.34-2.08.01-3.72-.96-4.86-1.07-1.26-2.97-1.92-5.49-1.92ZM76.4,54.67c-.41,2.7-2.48,2.7-4.48,2.7h-1.14l.8-5.05c.05-.31.31-.53.62-.53h.52c1.36,0,2.64,0,3.31.78.4.46.52,1.15.36,2.1Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M98.06,54.59h-3.61c-.31,0-.57.22-.62.53l-.16,1.01-.25-.37c-.78-1.13-2.52-1.51-4.26-1.51-3.99,0-7.39,3.02-8.06,7.26-.34,2.11.14,4.13,1.34,5.54,1.1,1.3,2.67,1.84,4.55,1.84,3.21,0,4.99-2.07,4.99-2.07l-.16,1c-.06.38.23.73.62.73h3.25c.51,0,.95-.37,1.03-.88l1.95-12.35c.06-.38-.24-.73-.62-.73ZM93.03,61.61c-.35,2.06-1.98,3.45-4.07,3.45-1.05,0-1.89-.34-2.42-.97-.53-.63-.73-1.53-.57-2.54.33-2.04,1.99-3.47,4.04-3.47,1.02,0,1.86.34,2.41.98.55.65.77,1.55.61,2.55Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M102.31,48.15l-3.09,19.68c-.06.38.23.73.62.73h3.11c.52,0,.96-.37,1.03-.88l3.05-19.32c.06-.38-.23-.73-.62-.73h-3.48c-.31,0-.57.23-.62.53Z"
		})
	]
});
export default SvgPaypal;
